<template>
  <div class="nav-padrao">
    <div
      id="nav"
      class="navbar"
      :class="{ 'navbar-gradient': menuActive, 'navbar-white': !menuActive }"
    >
      <b-navbar toggleable="lg">
        <!-- Menu toggle -->
        <b-navbar-toggle @click="onClickMenu" target="nav-collapse">
          <template v-slot:default="{ expanded }">
            <b-icon
              v-if="expanded"
              icon="x"
              class="icone-toggle2"
              :class="{ toggle2: isActive }"
              font-scale="2"
            ></b-icon>
            <b-icon
              v-else
              icon="list"
              class="icone-toggle"
              :class="{ toggle2: isActive }"
              font-scale="2"
            ></b-icon>
          </template>
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-brand
            id="inicio"
            href="#homesection"
            class="texto-menu nav-link nav-link-ltr"
            :class="{ link2: isActive }"
            >{{ $t("inicioNav") }}</b-navbar-brand
          >
          <b-navbar-brand
            id="about"
            href="#sobre"
            class="texto-menu nav-link nav-link-ltr"
            :class="{ link2: isActive }"
            >{{ $t("sobreNav") }}</b-navbar-brand
          >
          <b-navbar-brand
            id="pal"
            href="#palestrantes"
            class="texto-menu nav-link nav-link-ltr"
            :class="{ link2: isActive }"
            >{{ $t("palesoNav") }}</b-navbar-brand
          >
          <b-navbar-brand
            id="patro"
            href="#patrocinadores"
            class="texto-menu nav-link nav-link-ltr"
            :class="{ link2: isActive }"
            >{{ $t("patroNav") }}</b-navbar-brand
          >
          <b-navbar-brand
            id="org"
            href="#organizacao"
            class="texto-menu nav-link nav-link-ltr"
            :class="{ link2: isActive }"
            >{{ $t("orgNav") }}</b-navbar-brand
          >

          <!-- Redes sociais na navbar -->
          <b-navbar-nav class="ml-auto elemento-pai">
            <b-navbar-brand class="ordenando-elemento-nav">
              <b-link href="https://www.facebook.com/setiufla/" target="_blank">
                <svg
                  class="rede-social-nav"
                  :class="{ rede2: isActive }"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 12.41 23.58"
                >
                  <path
                    d="M12.44,1.25h-3C6.12,1.25,4,3.53,4,7.05V9.73H1a.47.47,0,0,0-.47.47h0v3.87a.48.48,0,0,0,.46.49H4v9.77a.48.48,0,0,0,.47.48H8.34a.48.48,0,0,0,.47-.48h0V14.56h3.5a.47.47,0,0,0,.47-.47h0V10.21a.48.48,0,0,0-.14-.34.44.44,0,0,0-.33-.14H8.8V7.46c0-1.09.25-1.64,1.63-1.64h2a.47.47,0,0,0,.47-.47h0V1.74a.48.48,0,0,0-.46-.49Z"
                    transform="translate(-0.5 -1.25)"
                  />
                </svg>
              </b-link>
              <b-link
                href="https://www.youtube.com/channel/UCHtvp-d8pujKyANPv3NCySA"
                target="_blank"
              >
                <svg
                  class="rede-social-nav"
                  :class="{ rede2: isActive }"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 33.455 23"
                >
                  <path
                    d="M274.033,7.341c-.907-1.614-1.892-1.911-3.9-2.024-2-.136-7.041-.192-11.4-.192s-9.411.056-11.411.19c-2,.115-2.987.41-3.9,2.026C242.48,8.953,242,11.73,242,16.619v.017c0,4.868.48,7.665,1.415,9.261.917,1.614,1.9,1.907,3.9,2.043,2,.117,7.042.186,11.413.186s9.4-.069,11.406-.184c2.006-.136,2.991-.429,3.9-2.043.943-1.6,1.42-4.393,1.42-9.261v-.017C275.455,11.73,274.978,8.953,274.033,7.341ZM254.545,22.9V10.352L265,16.625Z"
                    transform="translate(-242 -5.125)"
                  />
                </svg>
              </b-link>
              <b-link
                href="https://www.instagram.com/setiufla/"
                target="_blank"
              >
                <svg
                  class="rede-social-nav"
                  :class="{ rede2: isActive }"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 25.055 25.055"
                >
                  <path
                    d="M339.5,16.028c0-4.123,0-6.185.732-7.789a8.111,8.111,0,0,1,4.006-4.006c1.6-.733,3.665-.733,7.789-.733s6.184,0,7.789.733a8.111,8.111,0,0,1,4.006,4.006c.732,1.6.732,3.666.732,7.789s0,6.185-.732,7.789a8.112,8.112,0,0,1-4.006,4.006c-1.6.732-3.665.732-7.789.732s-6.184,0-7.789-.732a8.111,8.111,0,0,1-4.006-4.006C339.5,22.212,339.5,20.151,339.5,16.028ZM352.028,9.4a6.632,6.632,0,1,0,6.632,6.632A6.633,6.633,0,0,0,352.028,9.4Zm0,10.777a4.145,4.145,0,1,1,4.144-4.145A4.15,4.15,0,0,1,352.028,20.173ZM360.041,8.9a.884.884,0,1,1-.883-.884A.883.883,0,0,1,360.041,8.9Z"
                    transform="translate(-339.5 -3.5)"
                  />
                </svg>
              </b-link>
            </b-navbar-brand>

            <!-- Mudar lingua padrao do site -->
            <b-navbar-brand>
              <b-link
                v-for="entry in languages"
                :key="entry.title"
                @click="changeLocale(entry.language)"
                :v-bind:squared="false"
                id="pt"
                class="mudar-idioma texto-menu"
                :class="{ menu2: isActive }"
                >{{ entry.title }}</b-link
              >
            </b-navbar-brand>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
export default {
  name: "Navbar",
  data() {
    return {
      menuActive: false,
      isActive: false,
      languages: [
        { language: "pt", title: "PT" },
        { language: "en", title: "/EN" }
      ]
    };
  },
  methods: {
    changeColorNav(condicao) {
      if (condicao == "setColor") {
        document.getElementById("nav").style.background =
          "linear-gradient(to right, #ffc107,#ff0000 )";
        document.getElementById("inicio").style.color = "#ffffff";
        document.getElementById("about").style.color = "#ffffff";
        document.getElementById("pal").style.color = "#ffffff";
        document.getElementById("patro").style.color = "#ffffff";
        document.getElementById("org").style.color = "#ffffff";
        this.isActive = true;
      } else if (condicao == "notSetColor") {
        document.getElementById("nav").style.background = "transparent";
        document.getElementById("inicio").style.color = "#191919";
        document.getElementById("about").style.color = "#191919";
        document.getElementById("pal").style.color = "#191919";
        document.getElementById("patro").style.color = "#191919";
        document.getElementById("org").style.color = "#191919";
        this.isActive = false;
      } else if (condicao == "setOpacity") {
        document.getElementById("nav").style.background =
          "linear-gradient(to right,rgba(255, 193, 7, 0.8),rgba(255, 0, 0, 0.8) )";
        document.getElementById("inicio").style.color = "#ffffff";
        document.getElementById("about").style.color = "#ffffff";
        document.getElementById("pal").style.color = "#ffffff";
        document.getElementById("patro").style.color = "#ffffff";
        document.getElementById("org").style.color = "#ffffff";
        this.isActive = true;
      }
    },
    changeLocale(locale) {
      i18n.locale = locale;
    },
    onClickMenu() {
      this.menuActive = !this.menuActive;
    }
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrolled = window.scrollY;
      const firstDiv = window.innerHeight;

      if (scrolled > firstDiv) {
        this.changeColorNav("setColor");
      } else if (scrolled > 1 && scrolled <= firstDiv) {
        this.changeColorNav("setOpacity");
      } else {
        this.changeColorNav("notSetColor");
      }
    });
  },
  computed: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.nav-padrao {
  .navbar {
    padding: 1em !important;
    z-index: 99;
    top: 0;
    width: 100vw;
    position: fixed;
    height: 10vh;
    display: flex;
    justify-content: flex-end;
    background-image: none;
  }
  .navbar-collapse {
    padding: 60px 60px;
  }
  .texto-menu {
    font-family: Roboto;
    font-size: 1em;
    font-weight: 500;
    color: #191919;
  }

  .rede-social-nav {
    cursor: pointer;
    padding-left: 0.2rem;
    padding-right: 0.8rem;
    height: 2.9vh;
    fill: #ff3b1c;
  }

  .nav-link {
    padding: 20px 0px;
    margin: 0px 20px;
    display: inline-block;
    position: relative;
  }

  .nav-link:hover {
    opacity: 1;
  }

  .nav-link::before {
    transition: 300ms;
    height: 3px;
    content: "";
    position: absolute;
    background: linear-gradient(to right, #ff0000, #ffc107);
  }

  .nav-link-ltr::before {
    width: 0%;
    bottom: 15px;
  }

  .nav-link-ltr:hover::before {
    width: 100%;
  }

  .navbar-toggler {
    border: none;
  }

  .icone-toggle2 {
    color: white;
    display: flex;
    justify-content: center !important;
  }

  .icone-toggle {
    color: #ff3b1c;
    display: flex;
    justify-content: center !important;
  }

  .toggle2 {
    color: #ffffff;
    display: flex;
    justify-content: center !important;
  }

  .menu2 {
    font-family: Roboto;
    font-size: 1em;
    font-weight: 500;
    color: #ffffff;
  }

  .link2::before {
    transition: 300ms;
    height: 3px;
    content: "";
    position: absolute;
    background: #ffffff;
  }

  .rede2 {
    cursor: pointer;
    height: 2.9vh;
    fill: #ffffff;
  }

  @media screen and (max-width: 991px) {
    .navbar {
      padding: 0px !important;
      top: 0;
      width: 100vw;
      position: fixed;
      display: flex;
      justify-content: center;
    }
    .navbar-gradient {
      background: linear-gradient(to right, #ffc107, #ff0000) !important;
    }

    .navbar-white {
      background: white;
    }

    .navbar-collapse {
      background: linear-gradient(to right, #ffc107, #ff0000);
    }

    .navbar-brand {
      color: #ffffff !important;
      margin-left: 1.2rem;
    }

    .nav-link {
      padding: 0px 20px !important;
      margin: 15px 0px !important;
      display: flex;
      position: relative;
    }

    .nav-link-ltr:hover::before {
      width: auto;
    }

    .rede-social-nav {
      cursor: pointer;
      float: left;
      fill: #ffffff;
    }

    .mudar-idioma {
      float: left;
      color: #ffffff !important;
      padding-top: 0.5em;
      margin-right: 0.1rem !important;
    }

    .texto-menu {
      font-family: Roboto;
      font-size: 1em;
      font-weight: 500;
    }

    .elemento-pai {
      display: flex;
      flex-direction: column;
    }

    .ordenando-elemento-nav {
      order: 1;
    }

    .ml-auto {
      margin-left: unset !important;
    }
  }

  @media screen and (width: 1024px) {
    .rede-social-nav {
      cursor: pointer;
      padding-left: 1em;
      height: 1.7vh;
      fill: #ff3b1c;
    }

    .rede2 {
      cursor: pointer;
      height: 1.7vh;
      fill: #ffffff;
    }

    .navbar {
      z-index: 99;
      top: 0;
      width: 100vw;
      position: fixed;
      height: 9vh;
      display: flex;
      justify-content: flex-end;
      background-color: transparent;
    }

    .texto-menu {
      font-family: Roboto;
      font-size: 1em;
      font-weight: 500;
    }

    .navbar-brand {
      padding-bottom: 0rem !important;
    }
  }
}
</style>
<style lang="scss">
.navbar-expand-lg {
  padding: 0px !important;
}
</style>
